export { ProductUrgentMessageLabel } from "./ProductUrgentMessageLabel";
export type { ProductUrgentMessageLabelProps } from "./ProductUrgentMessageLabel";
